export function isRecaptchaPage(pages, path) {
    let is_recaptcha = false;

    for(let p in pages) {
        if(path.startsWith(pages[p])) {
            is_recaptcha = true;
            break;
        }
    }

    return is_recaptcha;
}